import ArrowDown from '@crehana/icons/ArrowDown';

import { useScrollContext } from './ScrollContext';

interface ScrollButtonProps {
  label?: string;
}

const ScrollDownButton: React.FC<
  React.PropsWithChildren<ScrollButtonProps>
> = ({ label }) => {
  const { scrollToNextSection } = useScrollContext();

  return (
    // TODO: talk with the code owner to fix this code so we can enable this rule again
    // eslint-disable-next-line react/button-has-type
    // biome-ignore lint/a11y/useButtonType: legacy code - a11y/useButtonType
    <button
      className={`relative z-7 flex items-center whitespace-no-wrap`}
      onClick={scrollToNextSection}
    >
      <p className="text-white mr-12 font-link">
        {label || 'Desliza hacia abajo'}
      </p>
      <ArrowDown color="white" size={24} />
    </button>
  );
};

export default ScrollDownButton;
